import { Navigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import LoadingAnimation from "../Loading/LoadingAnimation";

const PublicRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAuth();

  if (loading) return <LoadingAnimation />;

  if (isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
